import type { CityConfig } from "../city-template/types";

export const elizabethtownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Elizabethtown",
  state: "Kentucky",
  stateAbbr: "KY",
  slug: "elizabethtown",
  route: "/elizabethtown",
  title: "Emergency Passport Elizabethtown, KY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Elizabethtown, KY — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Hardin County, Fort Knox military families, and E-town residents. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Elizabethtown, KY",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Elizabethtown and Hardin County travelers get their expedited passports as quickly as 24 hours. Serving Fort Knox military families, Elizabethtown Community College students, and the growing E-town community. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Elizabethtown%20Kentucky%20downtown%20cityscape%20with%20modern%20development%20along%20Ring%20Road%2C%20Hardin%20County%20courthouse%20with%20classic%20architecture%2C%20suburban%20residential%20neighborhoods%20with%20trees%2C%20Fort%20Knox%20military%20base%20visible%20in%20distant%20background%2C%20warm%20afternoon%20sunlight%20with%20clear%20sky%2C%20clean%20cityscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20panoramic%20view%20of%20growing%20Kentucky%20town%20with%20rolling%20hills%20and%20green%20landscape%2C%20wide%20landscape%20view&width=1800&height=700&seq=elizabethtown-hero-001&orientation=landscape",
  heroImageAlt: "Elizabethtown Kentucky downtown with Hardin County courthouse and suburban neighborhoods at golden hour",
  geoPosition: "37.6941;-85.8591",
  geoPlacename: "Elizabethtown, Kentucky",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "77 W Jackson Blvd, Suite 1200, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 360 miles from Elizabethtown via I-65 and I-90",
  },
  nearbyCitiesZips: [
    { name: "Elizabethtown", zips: "42701, 42702" },
    { name: "Radcliff", zips: "40160" },
    { name: "Fort Knox", zips: "40121, 40122" },
    { name: "Shepherdsville", zips: "40165, 40166" },
    { name: "Hodgenville", zips: "42748" },
    { name: "Bardstown", zips: "40004, 40013, 40048, 40051, 40057, 40067, 40071, 40075, 40078, 40086, 40107, 40110, 40119, 40121, 40140, 40142, 40143, 40144, 40145, 40146, 40150, 40152, 40155, 40157, 40160, 40161, 40162, 40165, 40170, 40175, 40176, 40177, 40178" },
    { name: "Louisville", zips: "40201, 40202, 40203, 40204, 40205, 40206, 40207, 40208, 40209, 40210, 40211, 40212, 40213, 40214, 40215, 40216, 40217, 40218, 40219, 40220, 40221, 40222, 40223, 40224, 40225, 40228, 40229, 40231, 40232, 40233, 40241, 40242, 40243, 40245, 40250, 40251, 40252, 40253, 40255, 40256, 40257, 40258, 40259, 40261, 40266, 40268, 40269, 40270, 40272, 40280, 40281, 40282, 40283, 40285, 40287, 40289, 40290, 40291, 40292, 40293, 40294, 40295, 40296, 40297, 40298, 40299" },
    { name: "Bowling Green", zips: "42101, 42102, 42103, 42104, 42128, 42129, 42170, 42171, 42172, 42173, 42174" },
    { name: "Lebanon", zips: "40033, 40034, 40048, 40049, 40050, 40051, 40052, 40061, 40062, 40068, 40069, 40078, 40082, 40084, 40088, 40098" },
    { name: "Springfield", zips: "40069" },
    { name: "Taylorsville", zips: "40071" },
    { name: "Mount Washington", zips: "40047" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Hardin County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Louisville", route: "/louisville" },
    { name: "Fast passport renewal in Bowling Green", route: "/cities/bowling-green" },
    { name: "Emergency passport help in Bardstown", route: "/cities/bardstown" },
    { name: "Urgent passport services in Frankfort", route: "/frankfort" },
    { name: "Same-day passport help in Lexington", route: "/lexington" },
    { name: "Passport courier services near Radcliff", route: "/radcliff" },
  ],
  fpcOfficeAddress: "500 W Jefferson St, Louisville, KY 40202",
  fpcOfficeNote: "Fast Passport Center serves Elizabethtown remotely via secure courier. We do not have a walk-in office in Elizabethtown — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Hardin County travelers.",
  fpcOfficeDistance: "Serving all of Hardin County, Fort Knox, and the E-town region",
  serviceAreaIntro: "From the Elizabethtown Towne Centre to the historic downtown district, from Fort Knox military housing to the growing residential developments along the Western Kentucky Parkway — Fast Passport Center serves the entire Elizabethtown community and surrounding region. We regularly help travelers from Radcliff, Shepherdsville, and Bardstown get their passports fast.",
  nearbyCitiesIntro: "We serve all Elizabethtown neighborhoods and nearby Hardin County cities including Radcliff, Fort Knox, Shepherdsville, Hodgenville, Bardstown, Louisville, Bowling Green, Lebanon, Springfield, Taylorsville, and Mount Washington. If you are in Hardin County, the Fort Knox area, or the E-town region, we have you covered.",
  howItWorksIntro: "Most Elizabethtown travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Elizabethtown travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Elizabethtown and Hardin County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Elizabethtown? Here are the most common ones we hear from Hardin County travelers.",
  statePageRoute: "/states/kentucky",
  statePageName: "Kentucky",
  dmvWebsite: "https://drive.ky.gov",
  dmvLabel: "Kentucky Transportation Cabinet — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Hardin County international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Sergeant James M.",
      location: "Fort Knox, KY",
      rating: 5,
      text: "I'm stationed at Fort Knox and received emergency leave orders for a family situation in Germany. My passport was expired. Fast Passport Center renewed it in 48 hours. They understood military urgency and processed everything while I was dealing with base logistics.",
      service: "Passport Renewal",
    },
    {
      name: "Amanda C.",
      location: "Elizabethtown, KY",
      rating: 5,
      text: "My son at Elizabethtown Community College needed a passport for a study abroad program to Costa Rica. Fast Passport Center helped with his new passport and got it done in 4 days. They were patient with all our questions as first-time applicants.",
      service: "New Passport",
    },
    {
      name: "Robert L.",
      location: "Radcliff, KY",
      rating: 5,
      text: "We planned a Disney cruise to the Bahamas for our grandchildren and realized my wife's passport had expired. Fast Passport Center got her renewal done in 3 days. Saved our family vacation that we'd been planning for a year.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer H.",
      location: "Shepherdsville, KY",
      rating: 5,
      text: "Had an emergency requiring travel to Mexico within 48 hours for a family medical situation. Fast Passport Center processed my emergency passport in 24 hours. Their compassion and speed during a stressful time was remarkable.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "elizabethtown-1",
      name: "Elizabethtown Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1111 N Dixie Ave",
      city: "Elizabethtown",
      state: "KY",
      zip: "42701",
      phone: "(270) 765-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.5 miles from downtown Elizabethtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major facility for Hardin County. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "elizabethtown-2",
      name: "Hardin County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "14 Public Square",
      city: "Elizabethtown",
      state: "KY",
      zip: "42701",
      phone: "(270) 765-2171",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from Hardin County Courthouse",
      website: "https://www.hcky.org/",
      websiteLabel: "Hardin County Clerk",
      notes: "Major county facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
    {
      id: "elizabethtown-3",
      name: "Radcliff Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Lincoln Trail Blvd",
      city: "Radcliff",
      state: "KY",
      zip: "40160",
      phone: "(270) 351-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.3 miles from downtown Radcliff",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Fort Knox and Radcliff residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "elizabethtown-4",
      name: "Shepherdsville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "545 Conestoga Pkwy",
      city: "Shepherdsville",
      state: "KY",
      zip: "40165",
      phone: "(502) 543-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Shepherdsville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bullitt County. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "elizabethtown-5",
      name: "Bardstown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 W Flaget St",
      city: "Bardstown",
      state: "KY",
      zip: "40004",
      phone: "(502) 348-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles from Elizabethtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Nelson County residents. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "elizabethtown-6",
      name: "Louisville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1415 S 7th St",
      city: "Louisville",
      state: "KY",
      zip: "40208",
      phone: "(502) 625-1111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "40 miles from Elizabethtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Jefferson County residents. Convenient for Louisville area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Elizabethtown area photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Hardin County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Elizabethtown applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Hardin County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Fort Knox military families and E-town residents often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Elizabethtown." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Elizabethtown address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Elizabethtown before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Elizabethtown for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5 hour drive to Chicago." },
    { q: "How fast can I renew my passport in Elizabethtown?", a: "Fast Passport Center offers fast passport renewal in Elizabethtown in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. Many cruise lines require your passport to be valid for at least 6 months beyond your travel date. We can expedite your passport renewal in Elizabethtown in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Elizabethtown?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — a 5.5 hour drive from Elizabethtown — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Hardin County residents." },
    { q: "Can I expedite a child passport in Elizabethtown?", a: "Yes. Fast Passport Center expedites child passports in Elizabethtown for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Hardin County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Elizabethtown with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Elizabethtown?", a: "With Fast Passport Center's emergency courier service, Elizabethtown travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Elizabethtown?", a: "Popular options include the Elizabethtown Main Post Office (42701), Hardin County Clerk (42701), Radcliff Post Office (40160), Shepherdsville Post Office (40165), Bardstown Post Office (40004), and Louisville Main Post Office (40208). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Elizabethtown?", a: "Same-day passports are only available at the Chicago Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option — without the 5.5 hour drive to Chicago." },
    { q: "What if I live on Fort Knox?", a: "We serve Fort Knox military families and all of Hardin County including Radcliff, Shepherdsville, Hodgenville, Bardstown, Louisville, Bowling Green, Lebanon, Springfield, Taylorsville, and Mount Washington. Our overnight shipping labels work from any UPS location, including near Fort Knox gates." },
    { q: "How much does expedited passport service cost in Elizabethtown?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
    { q: "Do you help with passport photos in Elizabethtown?", a: "We guide you on exact photo requirements and can recommend locations near you. Many CVS, Walgreens, and FedEx locations in Elizabethtown offer passport photo services. We review your photos before submission to ensure they meet State Department standards." },
    { q: "What documents do I need for a first-time passport in Elizabethtown?", a: "You'll need proof of citizenship (birth certificate or naturalization certificate), government-issued photo ID (driver's license or REAL ID), two passport photos, and payment. We provide a complete checklist and review your documents before you visit the acceptance clerk." },
    { q: "Can you help with a child's passport in Elizabethtown?", a: "Yes. Child passports require both parents (or notarized consent from the absent parent), the child's birth certificate, and both parents' IDs. We walk Hardin County families through the entire process and help schedule acceptance clerk appointments." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Elizabethtown", address: "1600 N Dixie Hwy, Elizabethtown, KY 42701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com" },
    { name: "Walgreens — Elizabethtown", address: "1000 N Dixie Ave, Elizabethtown, KY 42701", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com" },
    { name: "Walmart — Elizabethtown", address: "1000 W Dixie Ave, Elizabethtown, KY 42701", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com" },
    { name: "Rite Aid — Elizabethtown", address: "1700 N Dixie Hwy, Elizabethtown, KY 42701", hours: "Mon–Sun: 8AM–10PM", website: "https://www.riteaid.com" },
    { name: "CVS Pharmacy — Radcliff", address: "500 W Lincoln Trail Blvd, Radcliff, KY 40160", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com" },
    { name: "Walmart — Shepherdsville", address: "545 Conestoga Pkwy, Shepherdsville, KY 40165", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com" },
    { name: "Walgreens — Bardstown", address: "100 W Flaget St, Bardstown, KY 40004", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com" },
    { name: "FedEx Office — Elizabethtown", address: "1111 N Dixie Ave, Elizabethtown, KY 42701", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.office.fedex.com" },
  ],
  dmvLocations: [
    {
      name: "Circuit Court Clerk — Hardin County",
      address: "14 Public Square, Elizabethtown, KY 42701",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Driver's license and REAL ID. Appointment recommended.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Bullitt County",
      address: "545 Conestoga Pkwy, Shepherdsville, KY 40165",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "REAL ID and driver's license renewals. Online booking available.",
      featured: false,
    },
    {
      name: "Circuit Court Clerk — Jefferson County",
      address: "527 W Jefferson St, Louisville, KY 40202",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Full-service center for Louisville area residents.",
      featured: true,
    },
    {
      name: "Circuit Court Clerk — Nelson County",
      address: "100 W Flaget St, Bardstown, KY 40004",
      hours: "Mon–Fri: 8AM–4:30PM",
      note: "Alternative for Nelson County residents. Walk-ins limited.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International",
      distance: "40 miles from Elizabethtown",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "The closest major airport for Hardin County travelers. Direct flights to major domestic and international hubs.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "Louisville Airport",
      featured: true,
    },
    {
      code: "LEX",
      name: "Blue Grass Airport (Lexington)",
      distance: "85 miles from Elizabethtown",
      address: "4000 Terminal Dr, Lexington, KY 40510",
      note: "Alternative regional airport with flights to major hubs.",
      flightUrl: "https://www.bluegrassairport.com/",
      flightLabel: "Blue Grass Airport",
      featured: false,
    },
    {
      code: "BWG",
      name: "Bowling Green-Warren County Regional",
      distance: "55 miles from Elizabethtown",
      address: "1100 Woody Hunt Ln, Bowling Green, KY 42103",
      note: "General aviation airport. Limited commercial service.",
      flightUrl: "https://www.bwgairport.com/",
      flightLabel: "BWG Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Birth & Death Certificates", desc: "Kentucky Office of Vital Statistics in Frankfort — order certified copies online, by mail, or in person for passport applications and name changes.", url: "https://www.chfs.ky.gov/agencies/dph/dehp/vsb/Pages/default.aspx" },
    { icon: "ri-heart-line", label: "Marriage Records", desc: "Hardin County Clerk — certified marriage licenses for name change passport applications and legal documentation.", url: "https://www.hcky.org/" },
    { icon: "ri-scales-line", label: "Divorce Decrees", desc: "Hardin Circuit Court Clerk — certified divorce decrees supporting passport name change or correction.", url: "https://kycourts.gov/Courts/Circuit-Court/Pages/Hardin.aspx" },
    { icon: "ri-global-line", label: "VitalChek — Nationwide Records", desc: "If your record was issued outside Kentucky, order certified copies online through VitalChek for delivery in 5–10 business days.", url: "https://www.vitalchek.com/" },
  ],
};